<template>
  <div>
    <div class="vx-row mt-2">
      <div class="vx-col w-full text-center text-primary">
        <div class="linea">&nbsp;</div>
      </div>
    </div>
    <vs-row>
      <vs-col vs-w="6" class="mt-3">
        {{ $t('client') }}
      </vs-col>
      <vs-col vs-w="6" vs-justify="flex-end" vs-align="flex-end" vs-type="flex">
        <action-icon
          icon="TrashIcon"
          v-if="index > 1"
          svgClasses="h-4 w-4 text-primary"
          :tooltip="$t('delete') | capitalize"
          @click="deleteClientApportionment(index)"
        />
      </vs-col>
    </vs-row>

    <select
      v-model="clientSelected"
      class="w-full vs-inputx vs-input--input my-1"
    >
      <option v-for="(option, i) in clients" :key="i" :value="option.ClientId">
        {{ option.ClientName }}
      </option>
    </select>

    <vs-row>
      <vs-col class="w-1/2">
        <vs-row>
          {{ $t('amount') }}
        </vs-row>
        <vs-row>
          <vs-input v-model="amountValue" class="w-full pr-2" type="text" v-on:keyup="changeAmountValue(amountValue)"/>
        </vs-row>
      </vs-col>
      <vs-col class="w-1/2 pl-2">
        <vs-row>
          {{ $t('percentage') }}
        </vs-row>
        <vs-row>
          <vs-input
            v-model="percentValue"
            class="w-full"
            type="number"
            min="0"
            max="100"
            v-on:keyup="changePercentValue(percentValue)"
          />
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  components: {
    ActionIcon,
  },
  props: {
    client: {
      type: [String, Number],
    },
    amount: {
      type: [Number],
      default: 0,
    },
    percent: {
      type: [Number],
      default: 0,
    },
    total: {
      type: [String, Number],
      default: 0,
    },
    clients: {
      type: Array(),
    },
    index: {
      type: Number,
    },
  },

  data() {
    return {
      amountValue: 0,
      percentValue: 0,
      clientSelected: ''
    }
  },
  methods: {
    changeValues() {
      let data = {
        client: this.clientSelected,
        amount: Number(this.amountValue),
        percent: Number(this.percentValue),
        index: this.index,
      }
      this.$emit('apoortionmentChangeValues', data)
    },
    deleteClientApportionment(index) {
      this.$emit('deleteClientApportionment', index)
    },
    changeAmountValue(val) {
      this.percentValue = (val * 100) / this.total
      this.changeValues()
    },
    changePercentValue(val) {
      this.amountValue = (val * this.total) / 100
      this.changeValues()
    },
    firstData(){
      this.amountValue = 0
      this.percentValue = 0
    }
  }, 
  mounted(){
    this.firstData()
  },
  watch:{
    clientSelected() {
      this.changeValues()
    },
  }
}
</script>
<style>
.linea {
  width: 100%;
  border-top: 3px solid #bc1300;
  position: relative;
  top: 10px;
  float: left;
}
.vs-tooltip {
  z-index: 54000;
}
</style>
